// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__sqa5Z","modal":"style_modal__isoOA","modal-content":"style_modal-content__qY7Vv","close":"style_close__3-dkJ","container":"style_container__kwTY8"};